module.exports = __webpack_public_path__ + "app/assets/images/logo-ahura.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/logo-ahura.png
// module id = 1120
// module chunks = 7